import * as React from 'react';
import {Builder} from 'components/Builder';
import {ExerciseObject} from 'api/exercise/types';
import {ExerciseBuilderProps} from './types';

/**
 * The component create or update an exercise.
 * @param {ExerciseBuilderProps} props
 * @return {React.ReactElement<ExerciseBuilderProps>}
 * @constructor
 */
export default function ExerciseBuilder(
    props: ExerciseBuilderProps,
): React.ReactElement<ExerciseBuilderProps> {
  return (
    <Builder<ExerciseObject> {...props}>
      {{
        header: () => (
          <Builder.Header>
            {{
              side: (
                <React.Fragment>
                  <Builder.Header.Preview />
                </React.Fragment>
              ),
              content: (
                <React.Fragment>
                  <Builder.Header.Title placeholder="Введите название упражнения" />
                  <Builder.Header.Description placeholder="Введите описание упражнения" />
                </React.Fragment>
              ),
            }}
          </Builder.Header>
        ),
        footer: (options) => (
          <Builder.Footer {...options} />
        )
      }}
    </Builder>
  );
}
